/**
 * Returns the supplied string in a "ready for url" state.
 *
 * Removes all non-alphanumeric characters and replaces spaces with a -
 *
 * @param fullVendorName The full, normal vendor name from the backend, ie "Tradent Supply"
 * @returns a url ready version of the string
 */
export default function getVendorNameForURL(fullVendorName: string) {
  // The first replacement for & does it for things like "Russman Debubblizer & Dental Supply" whle the second takes care of "T&P Supply" to prevent the url from being "tandp-supply"
  return fullVendorName
    .toLowerCase()
    .replace(" & ", " and ")
    .replace("&", " and ")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .replace(/\s/g, "-");
}
